import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getCommentsCount = async (post_id) => {
  const { count, error } = await supabase
    .from('post_comments')
    .select('*', { count: 'exact', head: true })
    .eq('post_id', post_id) 

  if (error) {
    throw new Error(error.message)
  }

  return count
}

export default function useCommentsCount(post_id: string) {
  return useQuery({
    queryKey: ['useCommentsCount', post_id],
    queryFn: () => getCommentsCount(post_id),
    enabled: Boolean(post_id),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
